import Vue from 'vue'
import VueRouter from 'vue-router'

import { index,rank,qa, qapure} from '../views/index'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Index',
    component: index
  },
  {
    path: '/rank',
    name: 'Rank',
    component: rank
  },
  {
    path: '/qa',
    name: 'Qa',
    component: qa    
  },
  {
    path: '/qapure',
    name: 'Qapure',
    component: qapure    
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
